import { render, staticRenderFns } from "./cartOrderTable.vue?vue&type=template&id=6651af5c&scoped=true&"
import script from "./cartOrderTable.vue?vue&type=script&lang=js&"
export * from "./cartOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./cartOrderTable.vue?vue&type=style&index=0&id=6651af5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651af5c",
  null
  
)

export default component.exports